/* Babyshower-banner (stående 55 × 130) — tillegg til br-banner-render.js.
   Lastes FØR banner-designer-seksjonen (Custom Liquid-seksjon i malen product.banner-babyshower).
   Fanger opp window.BannerRender når hovedfila definerer den, og legger til fonter, design og egen tegning.
   Lokalt (lag_banner.py / demo) lastes den ETTER hovedfila — da legges tillegget på med en gang. */
(function (root) {
  const SRC = (document.currentScript && document.currentScript.src) || '';
  const asset = n => SRC ? SRC.replace(/br-babyshower\.js.*$/, n) : 'fonts/' + n.replace(/^br-/, '');
  try {
    const st = document.createElement('style');
    st.textContent =
      `@font-face{font-family:BRCormorant;src:url("${asset('br-CormorantGaramond.ttf')}");font-weight:300 700;font-display:block}` +
      `@font-face{font-family:BRGreatVibes;src:url("${asset('br-GreatVibes.ttf')}");font-weight:400;font-display:block}` +
      `.br-prev:has(> svg[data-baby]){width:min(100%,calc(74vh / 2.364));margin:0 auto}` +
      `@media(max-width:900px){.br-prev:has(> svg[data-baby]){width:calc(40vh / 2.364)}}` +
      `.br-designs:has(svg[data-baby]){grid-template-columns:repeat(4,1fr)}` +
      `.br:has(.br-prev svg[data-baby]) .br-label:has(+ #br-photoyn),.br:has(.br-prev svg[data-baby]) #br-photoyn{display:none}`;
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  let _ctx;
  const FONTS_ADD = {
    cormorant: { name: 'Klassisk', css: 'BRCormorant', weight: 500, cap: 0.63 },
    greatvibes: { name: 'Elegant løkke', css: 'BRGreatVibes', weight: 400, cap: 0.66 }
  };
  function emWidth(text, f, weight) {
    _ctx = _ctx || document.createElement('canvas').getContext('2d');
    _ctx.font = `${weight || f.weight} 100px ${f.css}`;
    return _ctx.measureText(text).width / 100;
  }
  function marks(o, W, H, b) {
    if (!o.marks) return '';
    let s = ''; const g = 25;
    if (o.maljer !== false) [g, H - g].forEach(yy => [g, W - g].forEach(xx => {
      s += `<circle cx="${xx}" cy="${yy}" r="1.5" fill="none" stroke="#888" stroke-width="0.25"/><path d="M${xx-2.5} ${yy}H${xx+2.5}M${xx} ${yy-2.5}V${yy+2.5}" stroke="#888" stroke-width="0.25"/>`;
    }));
    const k = 'stroke="#000" stroke-width="0.25"';
    [[0, 0, -1, -1], [W, 0, 1, -1], [0, H, -1, 1], [W, H, 1, 1]].forEach(([x, y, dx, dy]) => {
      s += `<path d="M${x + dx*(b+2)} ${y}H${x + dx*(b+10)}M${x} ${y + dy*(b+2)}V${y + dy*(b+10)}" ${k}/>`;
    });
    if (o.order) s += `<text x="${-b}" y="${-b-4}" font-family="Helvetica,Arial,sans-serif" font-size="4" fill="#000">${esc(o.order)}</text>`;
    return s;
  }
  const hjerte = (cx, cy, s, col) => `<path transform="translate(${cx} ${cy}) scale(${s})" fill="${col}" d="M0 0.9C-0.35 0.6 -1 0.25 -1 -0.25C-1 -0.62 -0.7 -0.85 -0.45 -0.85C-0.22 -0.85 -0.06 -0.7 0 -0.55C0.06 -0.7 0.22 -0.85 0.45 -0.85C0.7 -0.85 1 -0.62 1 -0.25C1 0.25 0.35 0.6 0 0.9Z"/>`;

  // [id, navn, stripefarge, mørk farge, stork-bilde (bylten farget i samme farge, 4096×2662)]
  const CDN = 'https://cdn.shopify.com/s/files/1/0526/7419/9720/files/';
  const BABY = [
    ['salvie', 'Salvie', '#C4CFBA', '#687C6C', CDN + 'babyshower-stork-salvie.jpg?v=1792859751'],
    ['rosa', 'Rosa', '#ECD0D0', '#9E6E74', CDN + 'babyshower-stork-rosa.jpg?v=1792859751'],
    ['lyseblaa', 'Lyseblå', '#C6D8E6', '#5C7892', CDN + 'babyshower-stork-lyseblaa.jpg?v=1792859751'],
    ['sand', 'Sand', '#E6D8C0', '#887258', CDN + 'babyshower-stork-sand.jpg?v=1792859751']
  ];
  const TERRA = '#B58060', PANEL = '#F8F6F0', BG = '#FAF9F5';

  // Oppsettet er tegnet i en 1000 px bred rute (skisse 24.10.2026), skaleres til W og sentreres loddrett.
  function layout(BR, D, o, W, H, b) {
    const F = BR.FONTS, k = W / 1000, y0 = (H - 2400 * k) / 2, X = v => v * k, Y = v => y0 + v * k, cx = W / 2, dark = D.dark;
    let s = `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="${BG}"/>`;
    const p = 34 * k, hw = p / 4, n = Math.ceil((W/2 + b) / p) + 1;
    for (let i = -n; i <= n; i++) { const c = cx + i * p; s += `<rect x="${c - hw}" y="${-b}" width="${2*hw}" height="${H+2*b}" fill="${D.swatch}"/>`; }
    const bue = (x0, x1, yt, yb) => { const r = (x1 - x0) / 2; return `M${x0} ${yb}V${yt + r}A${r} ${r} 0 0 1 ${x1} ${yt + r}V${yb}Z`; };
    s += `<path d="${bue(X(90), X(910), Y(170), Y(2190))}" fill="${PANEL}"/>`;
    s += `<path d="${bue(X(116), X(884), Y(196), Y(2164))}" fill="none" stroke="${dark}" stroke-width="${4*k}"/>`;
    // storken ligger innenfor 10,5–92,5 % × 5–84 % av bildet; hvit bakgrunn blandes bort (multiply)
    const fx0 = 0.105, fx1 = 0.925, fy0 = 0.05, fy1 = 0.84, iw = 700 / (fx1 - fx0), ih = iw * 2662 / 4096, href = BR.asset(D.stork);
    s += `<image href="${href}" xlink:href="${href}" x="${X(150 - fx0 * iw)}" y="${Y(370 - fy0 * ih)}" width="${X(iw)}" height="${X(ih)}" style="mix-blend-mode:multiply" preserveAspectRatio="none"/>`;
    const tekst = (t, y, f, size, sp, col, w, ekstra) => {
      const fs = size * k, ls = sp * k;
      return `<text x="${cx + ls/2}" y="${Y(y)}" text-anchor="middle" font-family="${F[f].css}" font-weight="${w || F[f].weight}" font-size="${fs}"${ls ? ` letter-spacing="${ls}"` : ''} fill="${col}"${ekstra || ''}>${esc(t)}</text>`;
    };
    const strek = (xa, xb, y) => `<path d="M${X(xa)} ${Y(y)}H${X(xb)}" stroke="${dark}" stroke-width="${2*k}"/>`;
    let y = 370 + 700 * (fy1 - fy0) * 2662 / 4096 / (fx1 - fx0) + 105;
    s += tekst('VELKOMMEN', y, 'cormorant', 86, 16, dark, 500); y += 78;
    const tilB = emWidth('TIL', F.cormorant, 500) * 48 + 20;
    s += tekst('TIL', y, 'cormorant', 48, 10, dark, 500) + strek(500 - tilB/2 - 90, 500 - tilB/2 - 25, y - 16) + strek(500 + tilB/2 + 25, 500 + tilB/2 + 90, y - 16);
    y += 225;
    const navn = (o.l1 || '').trim();
    if (navn) { const ew = emWidth(navn, F.greatvibes); s += tekst(navn, y, 'greatvibes', Math.min(250, ew > 0 ? 680 / ew : 250), 0, TERRA); }
    y += 170; s += tekst('BABY', y, 'cormorant', 120, 12, dark, 500);
    y += 125; s += tekst('SHOWER', y, 'cormorant', 120, 12, dark, 500);
    y += 85; s += strek(350, 472, y) + strek(528, 650, y) + hjerte(cx, Y(y - 4), 13 * k, dark);
    y += 100; s += tekst('EN LITEN', y, 'cormorant', 54, 9, dark, 600);
    y += 115; s += tekst('en', y, 'greatvibes', 150, 0, dark);
    y += 95; s += tekst('ER PÅ VEI!', y, 'cormorant', 54, 9, dark, 600);
    y += 85; s += hjerte(cx, Y(y - 14), 15 * k, dark);
    y += 85;
    const dato = (o.l2 || '').trim().toLocaleUpperCase('nb');
    if (dato) { const ew = emWidth(dato, F.cormorant, 600) + dato.length * 7 / 46; s += tekst(dato, y, 'cormorant', Math.min(46, ew > 0 ? 680 / ew : 46), 7, TERRA, 600, ' style="font-variant-numeric:lining-nums"'); }
    return s;
  }

  let _n = 0;
  function patch(BR) {
    if (!BR || BR.__baby) return BR;
    BR.__baby = true;
    Object.assign(BR.FONTS, FONTS_ADD);
    // designerens tegngrense skaleres med bredde/høyde fra 130×40 (×(W/H)/3,25); verdiene under gir 16 / 24 tegn på 55×130
    BABY.forEach(([id, name, c, d, img]) => BR.DESIGNS['babyshower_' + id] = {
      name, swatch: c, dark: d, stork: img, baby: true, font: 'greatvibes', fastFont: true, max1: 123, max2: 184, thumb: { W: 550, H: 1300 },
      colors: { l1: TERRA, l2: TERRA }, photo: { cx: 0, cy: 0, r: 1, ring: d }, box: { photo: [0, 0, 0, 0], none: [0, 0, 0, 0] }, draw() { return ''; }
    });
    const orig = BR.render;
    BR.render = function (o) {
      const D = BR.DESIGNS[o.design];
      if (!D || !D.baby) return orig(o);
      let W = o.W, H = o.H; if (W > H) { W = D.thumb.W; H = D.thumb.H; }   // miniatyrer tegnes liggende i designeren → bruk stående
      const b = o.bleed || 0, M = o.marks ? 12 : 0, id = 'brb' + (++_n);
      const vx = -b - M, vy = -b - M, vw = W + 2*(b+M), vh = H + 2*(b+M);
      return `<svg data-baby="1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="${vx} ${vy} ${vw} ${vh}" width="${vw}mm" height="${vh}mm">` +
        `<defs><clipPath id="${id}T"><rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}"/></clipPath></defs><g clip-path="url(#${id}T)">` +
        layout(BR, D, o, W, H, b) + `</g>` + marks(o, W, H, b) + `</svg>`;
    };
    return BR;
  }

  if (root.BannerRender) patch(root.BannerRender);
  else {
    let v;
    Object.defineProperty(root, 'BannerRender', { configurable: true, enumerable: true, get() { return v; }, set(x) { v = patch(x); } });
  }
})(typeof window !== 'undefined' ? window : globalThis);